import { Component, Input, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { Store } from "@ngrx/store";
import { take } from "rxjs/operators";
import { AppState } from "src/app/state";
import { ReasoningType } from "src/app/model/reasoning/ReasoningType";
import { selectReasoningByType } from "src/app/state/reasoning/reasoning.selectors";
import * as ReasoningActions from "src/app/state/reasoning/reasoning.actions";

@Component({
    standalone: true,
    selector: "app-reasoning",
    templateUrl: "./reasoning.component.html",
    styleUrls: ["./reasoning.component.scss"],
    imports: [CommonModule, FormsModule, MatFormFieldModule, MatInputModule],
})
export class ReasoningComponent implements OnInit {
    @Input() reasoningType: ReasoningType;
    @Input() title: string;
    @Input() guidelines: string;
    @Input() placeholder: string[] = [];

    text = "";

    constructor(private store: Store<AppState>) {}

    get placeholderText(): string {
        return this.placeholder.length
            ? this.placeholder.join("\n")
            : "Enter your reasoning here...";
    }

    ngOnInit(): void {
        this.store
            .select(selectReasoningByType(this.reasoningType))
            .pipe(take(1))
            .subscribe((entry) => {
                if (entry) {
                    this.text = entry.reasoning;
                }
            });
    }

    onBlur(): void {
        this.store.dispatch(
            ReasoningActions.updateReasoning({
                entry: {
                    reasoningType: this.reasoningType,
                    reasoning: this.text,
                },
            }),
        );
    }
}
